"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hero = void 0;
const organism_1 = require("./organism");
const props_1 = require("../common/props");
/**
 * The hero organism.
 * @category Organisms
 */
class Hero extends organism_1.Organism {
    constructor(organisms) {
        super("Hero", organisms);
        this.availableColors = new props_1.PropertyStringSelectable("Available Colors", false, this, { selectables: ["Colored", "Black", "White"] });
        this.verticalGap = new props_1.PropertyNumberSelectable("Hero Vertical Gap", false, this, [1, 2, 3, 4, 5], 2);
        this.verticalPadding = new props_1.PropertyNumberSelectable("Hero Vertical Padding", false, this, [1, 2, 3, 4, 5], 2);
        this.title = new props_1.PropertyStringSelectable("Hero Title", false, this, {
            selectables: [Hero.DISPLAY1, Hero.DISPLAY2, Hero.H1],
            defaultValue: Hero.DISPLAY1,
        });
        this.body = new props_1.PropertyStringSelectable("Hero Body", false, this, {
            selectables: [Hero.BODY1, Hero.BODY2, Hero.BODY3, Hero.BODY1BOLD, Hero.BODY2BOLD, Hero.BODY3BOLD],
            defaultValue: Hero.BODY1,
        });
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.availableColors.deserialize(obj.availableColors);
        this.verticalGap.deserialize(obj.verticalGap);
        this.title.deserialize(obj.title);
        this.body.deserialize(obj.body);
    }
    serialize() {
        const obj = {};
        obj.availableColors = this.availableColors.serialize();
        obj.verticalGap = this.verticalGap.serialize();
        obj.title = this.title.serialize();
        obj.body = this.body.serialize();
        return obj;
    }
}
exports.Hero = Hero;
Hero.DISPLAY1 = "Display 1";
Hero.DISPLAY2 = "Display 2";
Hero.H1 = "H1";
Hero.BODY1 = "Body 1";
Hero.BODY2 = "Body 2";
Hero.BODY3 = "Body 3";
Hero.BODY1BOLD = "Body 1 - Bold";
Hero.BODY2BOLD = "Body 2 - Bold";
Hero.BODY3BOLD = "Body 3 - Bold";
